// extracted by mini-css-extract-plugin
export default {"notificationForm":"styles_notificationForm__B0xVp","header":"styles_header__A+xRL"};